var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5--\\u0421\\u041A--|---Web-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-13-\\u0421\\u041A-|-\\u0412-\\u0418\\u0441\\u043F\\u043E\\u043B\\u043D\\u0435\\u043D\\u0438\\u0438-|-\\u0417\\u0430\\u043C\\u0435\\u043D\\u0430-\\u0421\\u041C\\u041F-|-\\u0441\\u0432\\u044F\\u0437\\u0430\\u043D\\u043D\\u0430\\u044F-\\u0437\\u0430\\u044F\\u0432\\u043A\\u0430",
    transform: "translate(-860.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(238.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "column_requests",
    transform: "translate(400.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F6FF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cards/\\u0412-\\u0418\\u0441\\u043F\\u043E\\u043B\\u043D\\u0435\\u043D\\u0438\\u0438/\\u0412-\\u043F\\u0443\\u0442\\u0438",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayCard"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#EBF0F9",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 339,
    height: 113,
    rx: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "info-card",
    transform: "translate(12.000000, 8.000000)",
    fontFamily: "Manrope-SemiBold, Manrope",
    fontSize: 14,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("g", {
    id: "problem",
    transform: "translate(8.000000, 32.000000)",
    fill: "#192233"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u041F\\u043E\\u0432\\u044B\\u0448\\u0435\\u043D\\u043D\\u043E\\u0435-\\u0434\\u0430\\u0432\\u043B\\u0435\\u043D\\u0438\\u0435,"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "\u041F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u043E\u0435 \u0434\u0430\u0432\u043B\u0435\u043D\u0438\u0435, \u041B\u0438\u0445\u043E\u0440\u0430\u0434\u043A\u0430")))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    fillOpacity: 0.3,
    fill: "#192233",
    x: 0,
    y: 0,
    width: 1441,
    height: 900
  }), /*#__PURE__*/React.createElement("rect", {
    id: "side-sheet",
    fill: "#FFFFFF",
    x: 820.569444,
    y: 0,
    width: 620.430556,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(852.591667, 221.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "link-area",
    fill: "#F1F6FF",
    x: 0,
    y: 0,
    width: 556.386111,
    height: 36,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/link",
    transform: "translate(8.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1271357,19.1074331 L12.4187377,19.8109311 C11.8046644,20.4195794 10.8059422,20.4201044 10.1922189,19.8109311 C9.89716972,19.5181569 9.73512017,19.129308 9.73512017,18.7159591 C9.73512017,18.3026103 9.89734472,17.9135864 10.1920439,17.6208122 L12.7995366,15.0337944 C13.3399351,14.4979459 14.3565073,13.7088731 15.0974552,14.443696 C15.4374793,14.7814451 15.9866278,14.7791701 16.3242018,14.4393211 C16.6619509,14.099472 16.6598509,13.5501485 16.3198268,13.2127495 C15.0603553,11.962903 13.1988855,12.1939023 11.57769,13.8024978 L8.9700223,16.3896906 C8.34439904,17.0107639 8,17.8367616 8,18.7159591 C8,19.5951567 8.34439904,20.4209794 8.9701973,21.0420527 C9.6140205,21.6808009 10.4594431,22 11.3052158,22 C12.1511634,22 12.9969361,21.6808009 13.6411093,21.0417027 L14.3500323,20.3380296 C14.6898814,20.0006306 14.6918064,19.4514821 14.3540573,19.111458 C14.0168332,18.771784 13.4671598,18.769859 13.1271357,19.1074331 Z M21.0294137,9.05773605 C19.6766675,7.71548979 17.7852727,7.64268999 16.5329762,8.88518653 L15.6499287,9.76175909 C15.3099046,10.0993331 15.3078046,10.6483066 15.6455537,10.9883307 C15.9833028,11.3283547 16.5324512,11.3302797 16.8724753,10.9927057 L17.7551728,10.1166581 C18.403896,9.47248489 19.2533437,9.73953415 19.8073921,10.2892076 C20.1027913,10.5819818 20.2650158,10.9710057 20.2650158,11.3843546 C20.2650158,11.7978784 20.1026163,12.1869023 19.8077421,12.4796765 L17.0257749,15.2394188 C15.7537034,16.5015153 15.1569551,15.909142 14.9023308,15.6564427 C14.5623067,15.3188686 14.0133333,15.3209686 13.6755842,15.6608177 C13.3378351,16.0006667 13.3399351,16.5499902 13.6799592,16.8873892 C14.2639326,17.4669876 14.9305057,17.7543368 15.6292787,17.7543368 C16.4848514,17.7543368 17.3885488,17.323488 18.2477965,16.4703654 L21.0297637,13.7106231 C21.655212,13.0895498 21.999961,12.2633771 21.999961,11.3841796 C21.999961,10.505332 21.655212,9.67915932 21.0294137,9.05773605 Z",
    id: "Icon",
    fill: "#365EDE"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.f17b8517.svg";
export { ForwardRef as ReactComponent };